module.exports = __webpack_public_path__ + "../resources/img/mon_graph_img7.e1ed2ac8.png";